import PropTypes from "prop-types";
import colors from "constants/colors";
import { useMediaQueryContext } from "lib/mediaQueryContext";

import IconChevronDown from "../svg/IconChevronDown";

import { Container, Header, Title, Icon, Content } from "./Accordion.styled";

const Accordion = ({
    className,
    title,
    children,
    active,
    onExpand,
    onCollapse,
    onClick,
    disabled,
    variant
}) => {
    const { mobileView } = useMediaQueryContext();

    function handleOnClick() {
        if (disabled) {
            return;
        }
        if (active) {
            onCollapse();
        } else {
            onExpand();
        }
    }

    return (
        <Container
            className={className}
            active={active}
            variant={variant}
            onClick={onClick}
        >
            <Header onClick={handleOnClick}>
                <Title>{title}</Title>
                {!disabled && (
                    <Icon chevronRight={variant === "box" && mobileView}>
                        <IconChevronDown fill={colors.peach} />
                    </Icon>
                )}
            </Header>
            <Content>{children}</Content>
        </Container>
    );
};

Accordion.propTypes = {
    className: PropTypes.string,
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    onExpand: PropTypes.func.isRequired,
    onCollapse: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(["box", "minimal"]).isRequired
};

Accordion.defaultProps = {
    className: undefined,
    disabled: false,
    onClick: () => {}
};

export default Accordion;
